<template lang="html">
      <div class="quick-banner">
          <div class="container">
                <header>
              <h1>产品展示</h1>
              <div class="bottom-nav">
                  <div @click="loadList($key)" v-for="one in typeName.general" class="bottom-type" :class="{active: generalId==$key}">
                      <p>{{one}}</p>
                  </div>
              </div>
          </header>

          </div>
        
    </div>
	<div class="container">
        <div v-if="!bookList.list||!bookList.list.length" style="text-align: center;">暂无数据</div>
		<div class="row" style="margin-top:20px">
		    <div v-for="one in bookList.list" class="col-xs-2 ">
                <div class="show-block">
                    <a v-link="{path :'/index/listenbookpc'}">
		    		<img :src="one.images" @error="imgError"/>
                    <div class="float-title">
                        <p>{{one.name}}</p>
                    </div>
		    	    </a>
                </div>
		   
		    </div>
		</div>
	</div>
	
	<!-- Modal -->
	<div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
	  <div class="modal-dialog modal-lg">
	    <div class="modal-content">
	      <div class="modal-header">
	        <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
	        <h4 class="modal-title" id="myModalLabel">Modal title</h4>
	      </div>
	      <div class="modal-body">
	        ...
	      </div>
	      <div class="modal-footer">
	        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
	        <button type="button" class="btn btn-primary">Save changes</button>
	      </div>
	    </div>
	  </div>
	</div>
	
	
</template>
<script>
    import M from '../assets/common.js'
    import C from '../assets/config.js'
    export default {
        data: () => ({
            postParam: {},
            host: C.host,
            bookList: {},
            pageOpt: {
                list: {
                    pageNo: 1
                }
            },
            typeName: {},
            generalId: 1
        }),
        created: function() {
            var self = this;
            M.getAllType("admin", function(data) {
                self.$set('typeName', data);
                self.loadList();
            })
        },
        methods: {
            imgError: function(index) {
                // let book = bookList.list[index];
                // let book = this.bookList.list[index];
                this.$set('bookList.list[' + index + '].logo', 'http://qiniu.ludanmall.com/472/commend/logo/千库网-素材书图片_1480562667018.png');

            },
            // 查询课件列表
            loadList: function(key) {
                (key || key === 0) && (this.generalId = key);
                let url = this.host + "wuyan/admin/norisuke",
                    params = {
                        pageNo: this.pageOpt.pageNo,
                        pageSize: 100,
                        generalId: this.generalId

                    },
                    self = this;
                M.load(url, params, function(data) {
                    if (data.code) {
//                        M.topRightInfoTips({
//                            title: data.message
//                        })
						data.data = [];
                    }
                    self.$set("bookList", data.data);
                    self.$log();
                }, 'get');

            }

        }
    }
</script>
<style scoped>
    /*头部次级导航*/
    
    .quick-banner {
        font-family: 微软雅黑;
        background-attachment: fixed;
        background-color: #3dccac;
        background-image: url(http://qiniu.ludanmall.com/472/shop/cube/Artboard%201_1479995902886.svg);
        /*height: 300px;*/
        padding-top: 50px;
        padding-bottom: 10px;
    }
    
    .quick-banner h1 {
        color: white;
        text-align: center
    }
    
    .bottom-nav {
        border-top: 2px solid white;
        margin-top: 60px
    }
    
    .bottom-type {
        color: white;
        padding: 5px;
        display: inline-block;
        margin: 5px 0;
        width: 14%;
        text-align: center;
        cursor: pointer;
    }
    
    .bottom-type p {
        margin: 0;
        font-size: 18px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
	.bottom-type.active {
		border-top: 2px solid #337ab7;
		margin: 0;
		color: #337ab7;
	}
    .row {
        margin: 0;
        padding: 0;
    }
    
    a:hover {
        text-decoration: none;
    }
    
    .show-block {
        position: relative;
        box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.4);
        min-height: 151px;
        margin: 15px 0;
    }
    
    .show-block img {
        height: 150px;
		display: block;
		margin: auto;
    }
    
    .float-title {
        background: rgba(0, 0, 0, 0.8);
        text-decoration: none;
        color: white;
        position: relative;
        width: 100%;
        bottom: 0px;
		height: 40px;
        font-family: 微软雅黑;
		display: flex;
		font-size: 12px;
		align-items: center;
    }
	.float-title p{
		margin: 0;
	}
</style>


// WEBPACK FOOTER //
// norisukeList.vue?792f0ba7